<script setup lang="ts">
import { cva } from "class-variance-authority";
import { computed } from "vue";

import { useLayout } from "@/layout/common/composables/layout";
const { calculatedMenuMode } = useLayout();
const props = defineProps({
  class: {
    type: String,
    default: "",
  },
});

const sidebarGroupContentVariants = cva("relative w-full flex flex-col gap-1", {
  variants: {
    variant: {
      horizontal: "!flex-row",
    },
  },
});

type MenuMode = "horizontal";

const sidebarGroupContentClass = computed(() => {
  return sidebarGroupContentVariants({
    variant: calculatedMenuMode.value as MenuMode,
    class: props.class,
  });
});
</script>

<template>
  <div :class="sidebarGroupContentClass">
    <slot />
  </div>
</template>
